export default __webpack_public_path__ + "transfix-maps/icons/D3.30f9b051fdb6c851df28e23113926e39.png";